const settings = {
	numericLocales: {
		language: "en-US",
		options: {
			maximumFractionDigits: 2,
			minimumFractionDigits: 2,
			useGrouping: false,
		},
	},
};
export default settings;
